import { render, staticRenderFns } from "./DetalleSolicitudRepresentacion.vue?vue&type=template&id=4b2427ba&"
import script from "./DetalleSolicitudRepresentacion.vue?vue&type=script&lang=js&"
export * from "./DetalleSolicitudRepresentacion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "DetalleSolicitudRepresentacion.vue"
export default component.exports